import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input } from '~/components/Form';
import { t, validCharacters } from '~/helpers';
import { storeMedidor, updateMedidor } from '~/store/modules/medidor/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector((state) => state.medidor);

  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        descricaomedidor: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            (value) => validCharacters(value)
          ),
        multiplicadormedidor: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.tamanhominimo').replace('%s', 1)),
        divisormedidor: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.tamanhominimo').replace('%s', 1)),
        casadecimallitromedidor: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(0, t('s.geral.validacao.valorminimo').replace('%s', 0)),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        ...initials,
        ...param,
        idcliente: client,
      };

      if (create) {
        await dispatch(storeMedidor(objSend, params));
      } else {
        await dispatch(updateMedidor(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            name="descricaomedidor"
            label={t('s.configuracao.medidor.descricaomedidor')}
          />

          <Input
            name="multiplicadormedidor"
            label={t('s.configuracao.medidor.multiplicadormedidor')}
            type="number"
          />

          <Input
            name="divisormedidor"
            label={t('s.configuracao.medidor.divisormedidor')}
            type="number"
          />

          <Input
            name="casadecimallitromedidor"
            label={t('s.configuracao.medidor.casadecimallitromedidor')}
            type="number"
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
